import { stringify } from '../libs/queryString';
import { Template } from '../web-api/domain/template';

export function getEditorLink({
  template,
  editorSessionId,
  editor2PetriOverrideQueryParam,
}: {
  template: Template;
  editorSessionId: string;
  editor2PetriOverrideQueryParam?: string;
}): string {
  const { metaSiteId } = template;
  return `https://manage.wix.com/edit-template/from-intro?${stringify({
    originTemplateId: metaSiteId,
    editorSessionId,
    petri_ovr: editor2PetriOverrideQueryParam,
  })}`;
}

export function getViewerLink({
  templateSlug,
  language,
  originUrl,
  clickedElement = 'view_button',
  editorSessionId,
}: {
  templateSlug: string;
  language: string;
  originUrl: string;
  clickedElement?: 'view_button' | 'thumbnail';
  editorSessionId: string;
}): string {
  return `https://${
    language === 'en' ? 'www' : language
  }.wix.com/website-template/view/html/${templateSlug}?${stringify({
    originUrl,
    tpClick: clickedElement,
    esi: editorSessionId,
  })}`;
}
